/* Soccer Locker — theme.js (global) */
(function () {
  'use strict';
  var SL = window.SL || (window.SL = {});

  /* ---------- utilidades ---------- */
  SL.money = function (cents) {
    var n = (cents || 0) / 100;
    var txt = n % 1 ? n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : n.toLocaleString('en-US');
    return String(SL.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '').replace(/\{\{\s*\w+\s*\}\}/, txt);
  };
  SL.$ = function (s, r) { return (r || document).querySelector(s); };
  SL.$$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  SL.toast = function (msg) {
    var t = document.getElementById('Toast');
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(SL._tt); SL._tt = setTimeout(function () { t.hidden = true; }, 2600);
  };
  SL.uid = function () { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); };
  SL.wa = function (text) {
    return 'https://wa.me/' + (SL.whatsapp || '') + '?text=' + encodeURIComponent(text);
  };

  /* ---------- carrito ---------- */
  function json(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'Error');
        return d;
      });
    });
  }
  SL.cart = {
    get: function () { return json(SL.routes.cart + '.js'); },
    add: function (items) {
      return json(SL.routes.cartAdd + '.js', { items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
        .then(function (res) { SL.cart.afterChange(res.sections); return res; });
    },
    update: function (updates) {
      return json(SL.routes.cartUpdate + '.js', { updates: updates, sections: 'cart-drawer' })
        .then(function (res) { SL.cart.afterChange(res.sections); return res; });
    },
    afterChange: function (sections) {
      if (sections && sections['cart-drawer']) SL.drawer.fill(sections['cart-drawer']);
      SL.cart.get().then(function (c) {
        var n = c.items.reduce(function (a, i) {
          return a + ((i.properties && i.properties._sl_parent) || String(i.variant_id) === String(SL.giftVariant) ? 0 : i.quantity);
        }, 0);
        SL.$$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
        document.dispatchEvent(new CustomEvent('sl:cart', { detail: c }));
      });
    }
  };

  /* ---------- drawer del carrito ---------- */
  SL.drawer = {
    el: function () { return document.getElementById('CartDrawer'); },
    fill: function (html) {
      var d = SL.drawer.el(); if (!d) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-drawer-inner]');
      var target = d.querySelector('[data-drawer-inner]');
      if (inner && target) target.innerHTML = inner.innerHTML;
    },
    open: function () {
      var d = SL.drawer.el(); if (!d) return;
      d.hidden = false; document.body.style.overflow = 'hidden';
      var c = d.querySelector('.drawer__close'); if (c) c.focus();
    },
    close: function () {
      var d = SL.drawer.el(); if (!d) return;
      d.hidden = true; document.body.style.overflow = '';
    },
    load: function () {
      return fetch(SL.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); })
        .then(function (s) { SL.drawer.fill(s['cart-drawer']); });
    }
  };

  /* ---------- modales genéricos (data-open / data-close) ---------- */
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-open]');
    if (op) {
      var m = document.getElementById(op.getAttribute('data-open'));
      if (m) { e.preventDefault(); m.hidden = false; document.body.style.overflow = 'hidden'; }
      return;
    }
    var cl = e.target.closest('[data-close]');
    if (cl) {
      var box = cl.closest('.drawer, .sheet');
      if (box) { e.preventDefault(); box.hidden = true; document.body.style.overflow = ''; }
      return;
    }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      qa.classList.add('is-loading');
      SL.cart.add([{ id: Number(qa.getAttribute('data-quick-add')), quantity: 1 }])
        .then(function () { if (document.body.classList.contains('template-cart')) location.reload(); else SL.drawer.open(); })
        .catch(function (err) { SL.toast(err.message); })
        .finally(function () { qa.classList.remove('is-loading'); });
      return;
    }
    var cartBtn = e.target.closest('[data-cart-toggle]');
    if (cartBtn && document.body.classList.contains('template-cart') === false && SL.drawer.el()) {
      e.preventDefault(); SL.drawer.load().then(SL.drawer.open);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    SL.$$('.drawer:not([hidden]), .sheet:not([hidden])').forEach(function (m) { m.hidden = true; });
    document.body.style.overflow = '';
  });

  /* ---------- drawer: qty y eliminar ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-drawer-qty]');
    if (!b) return;
    e.preventDefault();
    var key = b.getAttribute('data-key');
    var qty = Number(b.getAttribute('data-drawer-qty'));
    var updates = {}; updates[key] = qty;
    SL.$$('[data-parent="' + b.getAttribute('data-uid') + '"]').forEach(function (a) {
      if (a.getAttribute('data-uid-key')) updates[a.getAttribute('data-uid-key')] = qty;
    });
    SL.cart.update(updates).catch(function (err) { SL.toast(err.message); });
  });

  /* ---------- búsqueda móvil ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-search-toggle]');
    if (!s) return;
    var p = document.getElementById('SearchPanel');
    if (!p) return;
    p.hidden = !p.hidden;
    if (!p.hidden) { var i = p.querySelector('input'); if (i) i.focus(); }
  });

  /* ---------- slideshow del hero ---------- */
  SL.$$('[data-hero]').forEach(function (hero) {
    var slides = SL.$$('.hero__slide', hero), texts = SL.$$('.hero__text', hero), dots = SL.$$('.hero__dots button', hero);
    if (slides.length < 2) return;
    var i = 0, ms = Number(hero.getAttribute('data-speed') || 5) * 1000, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      [slides, texts, dots].forEach(function (list) {
        list.forEach(function (el, k) { el.classList.toggle('is-active', k === i); if (el.tagName === 'BUTTON') el.setAttribute('aria-current', k === i); });
      });
    }
    function play() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, ms); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); }
      x0 = null;
    });
    play();
  });

  /* ---------- tabs de categorías ---------- */
  SL.$$('[data-tabs]').forEach(function (root) {
    var tabs = SL.$$('[role=tab]', root), panels = SL.$$('[role=tabpanel]', root);
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === k); x.classList.toggle('is-active', j === k); });
        panels.forEach(function (p, j) { p.hidden = j !== k; });
      });
    });
  });

  /* ---------- oferta "¿No sabes qué elegir?" ---------- */
  SL.$$('[data-bundle]').forEach(function (root) {
    var promo = Number(root.getAttribute('data-promo') || 0) * 100;
    function calc() {
      var units = [], items = [];
      SL.$$('[data-bundle-item]', root).forEach(function (it) {
        var q = Number(it.querySelector('output').value || 0);
        var price = Number(it.getAttribute('data-price'));
        var sel = it.querySelector('select');
        var vid = sel ? sel.value : it.getAttribute('data-variant');
        if (q > 0) items.push({ id: Number(vid), quantity: q });
        for (var n = 0; n < q; n++) units.push(price);
      });
      var sub = units.reduce(function (a, b) { return a + b; }, 0);
      var disc = units.length > 1 ? (units.length - 1) * promo : 0;
      root.querySelector('[data-b-sub]').textContent = SL.money(sub);
      root.querySelector('[data-b-disc]').textContent = '−' + SL.money(disc);
      root.querySelector('[data-b-total]').textContent = SL.money(sub - disc);
      root.querySelector('[data-b-count]').textContent = units.length;
      var btn = root.querySelector('[data-b-add]');
      btn.disabled = units.length === 0;
      return items;
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.qty button');
      if (b) {
        var o = b.parentNode.querySelector('output');
        o.value = Math.max(0, Math.min(10, Number(o.value) + (b.classList.contains('plus') ? 1 : -1)));
        calc(); return;
      }
      var add = e.target.closest('[data-b-add]');
      if (add) {
        var items = calc(); if (!items.length) return;
        add.classList.add('is-loading');
        SL.cart.add(items).then(function () { SL.drawer.open(); })
          .catch(function (err) { SL.toast(err.message); })
          .finally(function () { add.classList.remove('is-loading'); });
      }
    });
    root.addEventListener('change', calc);
    calc();
  });

  /* ---------- formulario de newsletter: mensaje ---------- */
  if (window.location.search.indexOf('customer_posted=true') > -1) SL.toast('¡Gracias por suscribirte!');
})();
